// import { flat } from "app/utils/utils";
// import { Navigate, useLocation } from "react-router-dom";
// import AllPages from "../routes";

import {FC} from 'react'
import {useSelector} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import {StoreModel} from '../../app/redux/types'
import {WithChildren} from '../helpers'
import ErrorDialog from '../partials/dialogs/ErrorDialog'

const AuthGuard: FC<WithChildren> = ({children}) => {
  const {currentUser} = useSelector((state: StoreModel) => state.globalStates)
  const {pathname} = useLocation()
  let canViewOtherPages = currentUser?.is_user_subscribed ? true : false
  const navigate = useNavigate()

  if (currentUser)
    if (currentUser.business_list.length <= 0) {
      canViewOtherPages = true
    } else if (pathname.includes('subscription')) {
      canViewOtherPages = true
    }

  return (
    <>
      {currentUser?.is_pay_by_user ? (
        <>
          {canViewOtherPages ? (
            children
          ) : (
            <>
              <ErrorDialog
                text={'Please add Subscription First'}
                open={'true'}
                onConfirmDialogClose={() => {
                  navigate('/app/subscriptions/add')
                }}
              />
              {children}
            </>
          )}
        </>
      ) : (
        children
      )}
    </>
  )
}

export default AuthGuard
